module.exports = __webpack_public_path__ + "static/qh_3.25961815.jpg";